import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaTiktok, FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import '../styles/ContactSection.css';

const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  
  const contactInfo = [
    {
      id: 1,
      title: 'Études Canada / Campus France / Contrats de travail',
      phone: '0658 14 94 63',
      icon: <FaPhone />
    },
    {
      id: 2,
      title: 'Études Roumanie, Suisse, Belgique, France, Espagne',
      phone: '0781 82 18 40',
      icon: <FaPhone />
    },
    {
      id: 3,
      title: 'Agent touristique',
      phone: '0561 23 47 93',
      icon: <FaPhone />
    },
    {
      id: 4,
      title: 'Autres contacts',
      phone: '044 22 00 58 / 07 74979498',
      icon: <FaPhone />
    }
  ];
  
  const socialMedia = [
    {
      id: 1,
      name: 'TikTok',
      icon: <FaTiktok />,
      link: 'https://www.tiktok.com/@saldaevoyage'
    },
    {
      id: 2,
      name: 'Instagram',
      icon: <FaInstagram />,
      link: 'https://www.instagram.com/saldaevoyage/'
    },
    {
      id: 3,
      name: 'Facebook',
      icon: <FaFacebook />,
      link: 'https://www.facebook.com/saldaevoyage/'
    },
    {
      id: 4,
      name: 'WhatsApp',
      icon: <FaWhatsapp />,
      link: 'https://wa.me/0658149463'
    }
  ];
  
  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <h2 className="section-title">Contactez-nous</h2>
        
        <div className="contact-content" ref={ref}>
          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
          >
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h3>Notre adresse</h3>
                <p>En face de la fac Targa Ouzemour, portail sis marché Edimco, Béjaïa 06000</p>
              </div>
            </div>
            
            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div>
                <h3>Email</h3>
                <p>contact@saldaevoyage.com</p>
              </div>
            </div>
            
            <div className="contact-phones">
              <h3>Nos numéros de téléphone</h3>
              <div className="phones-list">
                {contactInfo.map((item) => (
                  <motion.div 
                    key={item.id} 
                    className="phone-item"
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.5, delay: 0.2 * item.id }}
                  >
                    {item.icon}
                    <div>
                      <h4>{item.title}</h4>
                      <p>{item.phone}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
            
            <div className="social-media">
              <h3>Suivez-nous</h3>
              <div className="social-icons">
                {socialMedia.map((item) => (
                  <motion.a 
                    key={item.id} 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-icon"
                    whileHover={{ scale: 1.2, rotate: 10 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-map"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8 }}
          >
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3196.883690768688!2d5.038793876167782!3d36.74936277226163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128d334b6bb6f463%3A0xe9c28aee1a5f1bc2!2sSALDAE%20VOYAGE!5e0!3m2!1sfr!2sdz!4v1741774774390!5m2!1sfr!2sdz" 
              width="100%" 
              height="100%" 
              style={{ border: 0, borderRadius: '8px' }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation Saldae Voyage"
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 